<script>
    /**
     * The sensitive-content menu item. Used from both branches of Top.svelte,
     * so signed-out visitors get the same control (the preference is a cookie,
     * not a user column).
     *
     * The 18+ dialog it triggers is NOT rendered here — selecting this item
     * closes the menu, which would destroy a dialog living in the same
     * subtree. SensitiveAgeDialog sits at the top-bar root instead.
     *
     * Deliberately not a DropdownMenu.CheckboxItem: the working precedent for
     * "menu item opens a dialog" in this codebase is a plain Item with
     * onSelect (media_assets/show.svelte's delete flow).
     */
    import { page } from '@inertiajs/svelte'
    import * as DropdownMenu from "~/components/ui/dropdown-menu";
    import { Eye, EyeOff, Check } from "@lucide/svelte";
    import { requestSensitiveToggle } from "~/components/sensitiveContent";

    function onSelect() {
        requestSensitiveToggle($page.props.show_sensitive, $page.props.sensitive_confirmed);
    }
</script>

<DropdownMenu.Item {onSelect}>
    <span class="flex w-full items-center gap-2">
        {#if $page.props.show_sensitive}
            <Eye size={14} />
        {:else}
            <EyeOff size={14} />
        {/if}
        <span class="flex-1">敏感內容</span>
        {#if $page.props.show_sensitive}
            <Check size={14} />
        {/if}
    </span>
</DropdownMenu.Item>
